var _rect, _path, _path2, _g, _path3, _g2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArticle2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 200,
    viewBox: "0 0 344 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_4136)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 200,
    rx: 32,
    fill: "#23242C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.878 -5.97238C368.984 -12.8918 369.05 -24.1082 357.021 -31.0237L193.954 -124.811C181.926 -131.73 162.357 -131.73 150.251 -124.811L-13.8779 -31.0276C-25.9837 -24.1082 -26.0496 -12.8919 -14.0208 -5.97628L149.046 87.8105C161.074 94.7298 180.643 94.7298 192.749 87.8105L356.878 -5.97238Z",
    fill: "#2D2F39",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.8779 187.529C-25.9838 194.417 -26.0494 205.583 -14.021 212.468L149.045 305.834C161.074 312.722 180.643 312.722 192.749 305.834L356.877 212.471C368.983 205.583 369.051 194.417 357.02 187.532L193.954 94.1663C181.925 87.2779 162.357 87.2779 150.251 94.1663L-13.8779 187.529Z",
    fill: "#2D2F39",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_48_4136)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 100,
    r: 50,
    fill: "white",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_48_4136)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_4136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 50,
    width: 100,
    height: 100
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222 100C222 72.3858 199.614 50 172 50C144.386 50 122 72.3858 122 100C122 127.614 144.386 150 172 150C199.614 150 222 127.614 222 100Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_4136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222 100C222 72.3858 199.614 50 172 50C144.386 50 122 72.3858 122 100C122 127.614 144.386 150 172 150C199.614 150 222 127.614 222 100Z",
    fill: "url(#paint0_radial_48_4136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 100C222 72.3858 199.614 50 172 50C144.386 50 122 72.3858 122 100C122 127.614 144.386 150 172 150C199.614 150 222 127.614 222 100Z",
    fill: "url(#paint1_radial_48_4136)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2968 123.28C94.5898 125.956 94.5643 130.294 99.2412 132.969L162.644 169.243C167.321 171.919 174.93 171.919 179.637 169.243L243.453 132.97C248.16 130.294 248.186 125.956 243.509 123.281L180.106 87.0072C175.429 84.3309 167.82 84.3309 163.113 87.0072L99.2968 123.28Z",
    fill: "url(#paint2_radial_48_4136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2968 123.28C94.5898 125.956 94.5643 130.294 99.2412 132.969L162.644 169.243C167.321 171.919 174.93 171.919 179.637 169.243L243.453 132.97C248.16 130.294 248.186 125.956 243.509 123.281L180.106 87.0072C175.429 84.3309 167.82 84.3309 163.113 87.0072L99.2968 123.28Z",
    fill: "url(#paint3_radial_48_4136)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M241.07 60.3298C245.622 57.7312 245.646 53.5188 241.124 50.9216L179.817 15.699C175.295 13.1003 167.937 13.1003 163.386 15.699L101.68 50.9201C97.1282 53.5188 97.1035 57.7312 101.626 60.3284L162.933 95.551C167.455 98.1496 174.812 98.1496 179.364 95.551L241.07 60.3298Z",
    fill: "url(#paint4_radial_48_4136)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M241.07 60.3298C245.622 57.7312 245.646 53.5188 241.124 50.9216L179.817 15.699C175.295 13.1003 167.937 13.1003 163.386 15.699L101.68 50.9201C97.1282 53.5188 97.1035 57.7312 101.626 60.3284L162.933 95.551C167.455 98.1496 174.812 98.1496 179.364 95.551L241.07 60.3298Z",
    fill: "url(#paint5_radial_48_4136)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M192.124 93.96L192.688 94.819C199.052 104.508 197.631 117.196 189.271 125.325C184.352 130.108 177.907 132.499 171.46 132.5C171.46 132.5 171.46 132.5 192.124 93.96Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.458 105.673L192.122 93.96C171.458 132.5 171.458 132.5 171.458 132.5C171.458 124.106 171.458 114.488 171.458 105.673Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.776 93.96L150.212 94.819C143.847 104.508 145.269 117.196 153.629 125.325C158.547 130.108 164.993 132.499 171.439 132.5C171.439 132.5 171.439 132.5 150.776 93.96Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.433 105.673L150.77 93.96C171.433 132.5 171.433 132.5 171.433 132.5C171.433 124.106 171.433 114.488 171.433 105.673Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.466 79.5063V99.7085L189.265 89.614L171.466 79.5063Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.461 79.5063L153.649 89.6137L171.461 99.7085V79.5063Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.461 62.5156L153.649 89.6195L171.461 79.4836V62.5156Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.466 79.4813L189.279 89.6174L171.466 62.5V79.4813Z",
    fill: "#00A3FF"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 172,
    cy: 100,
    r: 49.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_48_4136",
    x: 52,
    y: -20,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_48_4136"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_48_4136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.724 114.352) rotate(-57.1946) scale(28.495 28.4091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_48_4136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.625 51.25) rotate(104.763) scale(50.4214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00395421,
    stopColor: "#FF955A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B469",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_48_4136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172 110.625) rotate(106.574) scale(54.7759 45.9081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508316,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825401,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_48_4136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.75 84.9999) rotate(103.928) scale(80.4916 67.4609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508316,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825401,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_48_4136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.625 94.375) rotate(-85.2921) scale(53.3049 67.1255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.407652,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740114,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_48_4136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.625 94.375) rotate(-85.2921) scale(53.3049 67.1255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.407652,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740114,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_4136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 200,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_48_4136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(122 50)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArticle2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/article_2.4fdee5a1014d7eb899674477160c843a.svg";